var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { checkKey, concatClassNames } from "../../utils/Functions";
import { BaseInput } from "./BaseInput";
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props, {}, props.checked || false) || this;
        _this.componentDidUpdate = function (prevProps) {
            if (prevProps.checked !== _this.props.checked)
                _this.dispatchValue(_this.props.checked, null, null, true);
        };
        _this.getPropertyName = function () { return "checked"; };
        _this.getEventType = function () { return "click"; };
        _this.changeCheck = function (e) {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange, checked = e.target.checked, nativeEvent = e.nativeEvent;
            if (disabled)
                return;
            _this.setState({ value: checked }, function () {
                if (onChange && !nativeEvent.more)
                    onChange(checked, e);
            });
        };
        _this.labelClick = function () { return _this.dispatchValue(!_this.state.value); };
        _this.onKeyUp = function (e) { return checkKey(e, _this.labelClick, _this.props.disabled, ["Space"]); };
        _this.render = function () {
            var value = _this.state.value, _a = _this.props, onBlur = _a.onBlur, onFocus = _a.onFocus, className = _a.className, disabled = _a.disabled, required = _a.required, style = _a.style, switchType = _a.switchType, change = function () { return _this.dispatchValue(!value); };
            if (switchType) {
                return React.createElement("div", { className: "dolfo-control switch" },
                    React.createElement("div", { style: style, className: concatClassNames(["dolfo-input-switch", value ? "checked" : "", disabled ? "disabled" : ""], className), tabIndex: !disabled ? 0 : null, onClick: change, onKeyUp: _this.onKeyUp, onFocus: onFocus, onBlur: onBlur },
                        React.createElement("span", null)),
                    _this.getLabel(),
                    React.createElement("input", { type: "checkbox", ref: _this.input, onChange: _this.changeCheck, required: required, checked: value }));
            }
            return React.createElement("div", { className: "dolfo-control checkbox" },
                React.createElement("div", { style: style, className: concatClassNames(["dolfo-input-checkbox", value ? "checked" : "", disabled ? "disabled" : ""], className), tabIndex: !disabled ? 0 : null, onClick: change, onKeyUp: _this.onKeyUp, onFocus: onFocus, onBlur: onBlur },
                    React.createElement(FontAwesomeIcon, { icon: faCheck })),
                _this.getLabel(),
                React.createElement("input", { type: "checkbox", ref: _this.input, onChange: _this.changeCheck, required: required, checked: value }));
        };
        return _this;
    }
    return Checkbox;
}(BaseInput));
export { Checkbox };
